<div #socailShare>
  <div *ngIf="shareType==='overlay'" class="fr-socail-share">
    <ng-template [ngTemplateOutlet]="shareMenu"></ng-template>
    <div class="fr-share-btns">
      <button class="share-btns" *ngIf="!isShareMenu" (click)="socialShare()" mat-button>
        <mat-icon class="share-btn-icon">share</mat-icon>
      </button>
      <button class="share-btns" *ngIf="isShareMenu" class="share-btns share-btn-raised" (click)="socialShare()" mat-raised-button>
        <mat-icon class="icon-Close"></mat-icon>
      </button>
      <app-fb-share *ngIf="both" [count]="sharedCounts?.fb" class="fbshare" [fundraiser]="fundraiser" [label]="label" position='PosOS1'>
      </app-fb-share>
      <app-whatsapp-share *ngIf="basicInfo?.social" [fundraiser]="fundraiser" [basicInfo]="basicInfo" [isFundraiserEnded]="isFundraiserEnded"
                          [label]="label" [count]="sharedCounts" position='8'>
      </app-whatsapp-share>
    </div>
  </div>
  <div *ngIf="shareType==='menu'">
    <!-- <ng-template [ngTemplateOutlet]="shareMenu"></ng-template> -->
    <button class="share-btns" mat-button [matMenuTriggerFor]="menu">
      <mat-icon class="share-btn-icon">share</mat-icon><span class="share-btn-txt">Share This Fundraiser</span>
    </button>
    <mat-menu #menu="matMenu" class="share-menus">
      <div *ngFor="let btn of shareButtons" class="social-share-desktop">
        <button *ngIf="btn.button!=='copy'" (click)="shareEvent(btn)" mat-menu-item>
          <mat-icon class="social-icon" [style.backgroundColor]="btn.color" [ngClass]="btn.icon"></mat-icon>
          <span [style.color]="btn.color" class="social-label">{{btn.label}}</span>
        </button>
      </div>
    </mat-menu>
  </div>
</div>

<!-- Share icons -->
<ng-template #shareMenu>
  <div class="share-menu-conatiner" *ngIf="isShareMenu">
    <div class="share-menu">
      <div [@listAnimation]="shareButtons.length" >
        <div *ngFor="let btn of shareButtons">
          <button *ngIf="btn.button!=='copy' && btn?.device!=='desktop'" class="social-options" (click)="shareEvent(btn)" mat-mini-fab>
            <mat-icon class="social-icon" [ngClass]="btn.icon"></mat-icon>
            <span class="social-label">{{btn.label}}</span>
          </button>
          <div *ngIf="btn.button=='copy'">
            <button class="social-options copyLink" (click)="shareEvent(btn)" mat-mini-fab>
              <mat-icon class="social-icon" [ngClass]="btn.icon"></mat-icon>
              <div class="socia-label-link">{{'https://ket.to/'+fundraiser?.custom_tag}}</div>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-template>

